export function buildWalletAvatarModel(walletAddress) {
  const safe = String(walletAddress || "").trim();
  const hue = safe ? hashStringToHue(safe) : 214;
  return {
    label: safe ? safe.slice(-2).toUpperCase() : "PM",
    backgroundColor: `hsl(${hue} 62% 36%)`,
    foregroundColor: "#f4f4f5"
  };
}

function hashStringToHue(value) {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) % 360;
  }
  return hash;
}
